import { PersonaRequestBody } from './PersonaRequestBody';

/**
 * @public
 */
export interface GetModelVariablesListRequestBody extends PersonaRequestBody {
  Models: string;
}
